var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 47,
    viewBox: "0 0 51 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.109375,
    y: 0.668457,
    width: 50.5062,
    height: 45.9735,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_83_513",
    transform: "scale(0.0128205 0.0140845)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_83_513",
    width: 78,
    height: 71,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABHCAMAAACee4HnAAAAM1BMVEVHcEw6Ojw6Ojw6Ojw6Ojw6Ojw6Ojw6Ojw6Ojw6Ojw6Ojw6Ojw6Ojw6Ojw6Ojw6Ojw6Ojy1/OkEAAAAEHRSTlMAIGAw8BDgwIBA0FCgcLCQSFsoSwAAAAlwSFlzAAALEgAACxIB0t1+/AAAA9pJREFUWIW1WOnasyoMDKssLrn/qz1PElAQ9bNve+ZPi8oYsgxBgLxOP8KiADL+EBEmRPsb4zziDBN6Bz+BS2hhwuk3bAAB8X+iU9HQj4mKfmL8iwMOOmMRNwCNiBlgRrRqePoDukDJAuARaUiDMDx9DRV1CDk+0Ln3dMGXpLW5pVN/WqxLRwVY1YbCSSiUhMK8C0VCtFuMMWZLy/kyUQJiKq+N5KQv6SzawmbS99ZFjpe2xXmm0L1WAPKu7kregKtsli+QoryFB1D9o2xid+Hv1nHGB8TW3L/7TrHrVrT7la9CoTnjbTP9K7oN0RUTf0E3UWgym/gLOsS1mHhLt/j3aYO4FBPv6MIw4xGmmHhHZxHX8Bqak3i5p+ve9QYL7dQPdNtndDPV2S1d2Yb2qtF9VYXuJr3ZY3qgW/llh2Kfax7AdCPXL+cishwtEQVbFCNNxzDXoaVajYj6gU4ClUouhUKnG0+E6ntbRuaBDqgHIv9WvVG0WF+tEwLKo5nFnMQNnugSuVYf7omyhRdMnBnNPdsX6EA3cwnqZj5dKqCd+Rgu0MvJFZ3u0vJf0K2cXNGZ970JnOTkig4sl5mKgtKcFZjmDt/q5OSSjmO1p641nfMVi0S5dVHiI12gSa6NZSNasbmDZzm5pIuW+gSPiRaUCl2mwVwYZhpwhiznuI10YLLU7u6bgLi0dDzgWu3l5JquXm+XdDXQZzm5oSOz1N5TNv9JPPb+MLmznNzQpdUBuCLwxF3/c8bWgRvk5JpuCNctTnJyTSei8gYnObmhY1GpGh4adaeVOTmskj/OcnJDJ4VYXc47c0HmDJJIjHJyQ6eLklnu4EQjp2lKRfzksh/l5IbONDpb/qKEKNadc+xOWrrTeZYfDrzFcNFurPW+0Hk29NydCGbpjX3XsvIeVY/0rZ7L2YjB+93c78I007cC1CqRCLzVh55r2ItsqfmpTxMDQD411Hb08QWKnCzd1CslV7KMuFpEO3cSpClp/KakeIeZ1/CIIe/ZNumq58dhcw0WhyS+wx6GENLJN3YNWyV94ZGyJgpg4vqOtmXj4oLF1k33JcxxsqTcqOJetSHjmHNP2CRsMUrRsaytfNqUU/Q8aNMjJOOTCHCxytMP2arZPP00/wSuYyOVAEliyDm6SKFcqMkTmI5Oqv7QNTaVqmKuB+PXWFktMh85a9vimTuwdA477DN0s0mtxe3zkWnOD7r+DL/7eq7pr6RlKV9PPlmr+GjKTlGRFhLKHpwjGDq31az8YLm1rvYMO/rQT9loK5OZc/PxKEu5Wtq0P4aiL1+nL1FmCSHfkgHAf4Vba7WGMkzeAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/service_icon.101fe9233d53d41e42c09c8c121c37a4.svg";
export { ForwardRef as ReactComponent };